import { LineTypeCode, LineTypeName } from "@/types";

export default function useGetLineTypeName(
  lineTypeCode: LineTypeCode
): LineTypeName {
  switch (lineTypeCode) {
    case LineTypeCode.Forward: {
      return LineTypeName.Forward;
    }
    case LineTypeCode.Backward: {
      return LineTypeName.Backward;
    }
    case LineTypeCode.Circular: {
      return LineTypeName.Circular;
    }
    case LineTypeCode.Shuttle: {
      return LineTypeName.Shuttle;
    }
    case LineTypeCode.Inside: {
      return LineTypeName.Inside;
    }
    default: {
      return LineTypeName.None;
    }
  }
}
